import Raphael from'../vendors/redraphael/source/raphael.core';Raphael.stopPartialEventPropagation=!0,Raphael._stopabsolutePath=!0;export default{extension:Raphael,name:'redraphael',type:'plugin'};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-core/src/_internal/redraphael/redraphael.js
// module id = null
// module chunks = 